import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type ResistanceNodeOptions = { emulateCost?: number } & SimpleManaNodeOptions

export default class ResistanceNode extends SimpleManaNode {

	static nodeType = 'ResistanceNode'
	static nodeName = "Resistance node"
	static nodeDesc = "Fail particles if mana levels are low"
	static nodeIcon = 'Ω'
	static category = NodeCategories.Logistics

	emulateCost

	constructor({ emulateCost = 99999999, ...rest }: ResistanceNodeOptions) {
		super(rest)

		this.emulateCost = emulateCost
	}

	allowEntry(particle: ManaParticle) {
		return this.getParticleTrueCost(this.emulateCost, particle) <= particle.source.mana
	}

	onScroll(dir: number) { }

	save() {
		return {
			...super.save(),

			emulateCost: this.emulateCost
		}
	}
}